import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { doc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';
import { useUser } from '../../context/UserContext';
import Swal from 'sweetalert2';
import UserNav from '../../components/navbar/user-nav';
import FooterTop from '../../components/footer-top';
import Footer from '../../components/footer';

export default function VerProyecto() {
  const { id } = useParams<{ id: string }>();
  const { user } = useUser();
  const navigate = useNavigate();

  const [proyecto, setProyecto] = useState<any>(null);
  const [inmobiliaria, setInmobiliaria] = useState<any>(null);
  const [propiedades, setPropiedades] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProyecto = async () => {
      if (!id || !user) return;

      try {
        const snap = await getDoc(doc(db, 'proyectos', id));
        if (!snap.exists()) {
          setLoading(false);
          return;
        }

        const data = snap.data();

        // Sprint 1 (F4-007): ownership check. ADMIN bypasea.
        const userRol = (user as any)?.rol;
        const userInmo = (user as any)?.inmobiliaria_doc_id;
        if (userRol !== 'ADMIN') {
          const inmoProyecto = data.inmobiliaria_doc_id || data.inmobiliaria_id;
          if (!userInmo || inmoProyecto !== userInmo) {
            Swal.fire({
              icon: 'error',
              title: 'No autorizado',
              text: 'Este proyecto no pertenece a tu inmobiliaria.',
            });
            navigate('/dashboard');
            return;
          }
        }

        setProyecto(data);

        // 🔍 Cargar inmobiliaria asociada
        if (data.inmobiliaria_id) {
          const inmoSnap = await getDocs(
            query(collection(db, 'inmobiliaria'), where('inmobiliaria_id', '==', data.inmobiliaria_id))
          );
          if (!inmoSnap.empty) {
            setInmobiliaria(inmoSnap.docs[0].data());
          }
        }

        // 🔍 Cargar propiedades vinculadas
        if (Array.isArray(data.propiedad_id) && data.propiedad_id.length > 0) {
          const propsSnap = await getDocs(query(
            collection(db, 'propiedades'),
            where('propiedad_id', 'in', data.propiedad_id.slice(0, 10)) // 🔹 Firestore limita a 10 elementos en 'in'
          ));
          setPropiedades(propsSnap.docs.map(d => ({ id: d.id, ...d.data() })));
        }

        setLoading(false);
      } catch (error) {
        console.error('Error al cargar proyecto:', error);
        setLoading(false);
      }
    };

    fetchProyecto();
  }, [id, user]);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <p className="text-muted">Cargando proyecto...</p>
      </div>
    );
  }

  if (!proyecto) {
    return (
      <div className="container py-5 text-center">
        <p className="text-danger">Proyecto no encontrado.</p>
      </div>
    );
  }

  return (
    <>
      <UserNav />
      <div className="container mt-5">
        <h2 className="mb-3">Proyecto: {proyecto.nombre}</h2>
        <p><strong>Descripción:</strong> {proyecto.descripcion}</p>
        <p><strong>Inmobiliaria:</strong> {inmobiliaria?.nombre || 'No disponible'}</p>

        <button className="btn btn-success my-3" onClick={() => navigate('/submit-property')}>
          + Agregar nueva propiedad al proyecto
        </button>

        <hr />
        <h4>Propiedades Vinculadas ({propiedades.length})</h4>
        <div className="row">
          {propiedades.map((p) => (
            <div className="col-md-4 mb-3" key={p.id}>
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{p.nombre}</h5>
                  <p>{p.tipo} - ${p.precio}</p>
                  <a className="btn btn-sm btn-outline-primary" href={`/ver-propiedad-admin/${p.id}`}>
                    Ver propiedad
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <FooterTop bg="theme-bg" />
      <Footer />
    </>
  );
}
